<app-dialog [(visible)]="visible" header="Motif du rejet" width="480px" [dismissableMask]="true">
  <div class="reject-dialog-body">
    <p class="reject-dialog-hint">
      <i class="pi pi-exclamation-triangle"></i>
      Expliquez clairement pourquoi ce document est rejeté. L'utilisateur en sera informé.
    </p>
    <textarea pTextarea [ngModel]="text()" (ngModelChange)="text.set($event)" rows="4" class="reject-textarea"
              [placeholder]="placeholder()"></textarea>
  </div>
  <div dialogFooter>
    <button pButton [text]="true" (click)="cancel.emit()" label="Annuler"></button>
    <button pButton severity="danger" [disabled]="confirmDisabled()" [loading]="loading()"
            (click)="confirm.emit()" icon="pi pi-send" label="Confirmer le rejet"></button>
  </div>
</app-dialog>
